export default "__VITE_ASSET__53W7JUt4__"